// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishListNew/OperationBtn.less
// module id = 966
// module chunks = 0